<template>
  <div class="selected-company">
    {{ $t("message.permissions.selectedCompany") }}:
    <span class="selected-company-name">
      {{ company.name }}
    </span>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "SelectedCompany",
  computed: {
    ...mapState({
      company: state => state.company.company
    })
  }
};
</script>

<style lang="scss" scoped>
.selected-company {
  font-weight: 500;
  @include font-size(14px);
  line-height: 17px;
  color: rgba($text, 0.4);
  display: flex;
  align-items: center;

  .selected-company-name {
    margin-left: $spacing / 2;
    margin-right: $spacing;
  }
}
</style>
